export default __webpack_public_path__ + "static/media/priority_high.5025e495.svg";